import React from "react"
import { Skeleton } from "antd"

const TableSkeleton = () => {
  return (
    <Skeleton
      style={{ width: "100%" }}
      active
      title={false}
      paragraph={{
        rows: 15,
      }}
    />
  )
}

export default TableSkeleton
